

import situacaoAluno from "@/enums/situacao-aluno.js"
import tipoDisciplina from "@/enums/tipo-disciplina"
import tabelaItem from "@/enums/tabela-item"

export const _util = {
    selecionar(id, consideraPai = false) {
        var elemento = document.getElementById(id)

        if (elemento) {
            if (!elemento.children[0].classList.contains("ja-selecionado")) {
                window.scrollTo({
                    top: (consideraPai ? elemento.parentElement.offsetTop : 0) + elemento.offsetTop,
                    behavior: "smooth",
                })

                elemento.children[0].classList.add("ja-selecionado")
                elemento.children[0].classList.add("selecionada")

                setTimeout(() => {
                    elemento.children[0].classList.remove("selecionada")
                }, 3000)
            }
        }
    },

    notaFormatada(valor) {
        return parseFloat(
            (valor ? String(valor) : "0").replace(",", ".")
        ).toFixed(1)
    },

    pegarDados() {
        const dados = JSON.parse(sessionStorage.getItem("dados"))

        if (dados) {
            return dados
        }
        return null
    },

    formatarDataLista(lista) {
        return lista.map(atividade => {
            if (atividade.data) {
                const [ano, mes, dia] = atividade.data.split("T")[0].split("-")
                atividade.data = `${dia}/${mes}/${ano}`
            }
            return atividade
        })
    },

    pegarDiaSemana(dataString) {
        const [dia, mes, ano] = dataString.split("/").map(Number)
        const data = new Date(ano, mes - 1, dia) // Ajuste do mês, pois é 0-indexado

        const diasSemana = [
            "Domingo",
            "Segunda-feira",
            "Terça-feira",
            "Quarta-feira",
            "Quinta-feira",
            "Sexta-feira",
            "Sábado",
        ]

        return diasSemana[data.getDay()]
    },

    formatarDataPorExtenso(dataString) {
        // Converter a string para um objeto Date
        const [ano, mes, dia, hora, minuto, segundo] = dataString.match(/\d+/g)
        const data = new Date(ano, mes - 1, dia, hora, minuto, segundo)

        // Formatar a data por extenso
        return new Intl.DateTimeFormat("pt-BR", {
            weekday: "long",
            day: "numeric",
            month: "long",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        }).format(data)
    },

    validarHorario(configuracao) {
        if (configuracao && configuracao.inicial && configuracao.final) {
            const dataAtual = new Date()
            const dataComparacaoInicial = this.dataComparacao(
                configuracao.inicial
            )
            const dataComparacaoFinal = this.dataComparacao(configuracao.final)

            return (
                dataAtual >= dataComparacaoInicial && dataAtual <= dataComparacaoFinal
            )
        }
        return null
    },

    dataComparacao(dataCompararar) {
        const [data, hora] = dataCompararar.split(" ")
        const [dia, mes, ano] = data.split("/").map(Number)
        const [horas, minutos] = hora.split(":").map(Number)

        return new Date(ano, mes - 1, dia, horas, minutos)
    },

    dataAtividade(data) {
        const [dia, mes, ano] = data.split("/").map(Number)
        return new Date(ano, mes - 1, dia)
    },

    /**
     * @param {*} dateString 12/03/2025 12:00
     * @returns 2025-03-12T12:00:00.000Z
     */
    formatToISOString(dateString) {
        const [day, month, year, hours, minutes] = dateString.split(/[/\s:]/).map(Number)
        const date = new Date(year, month - 1, day, hours, minutes)
        return date.toISOString()
    },

    // ordernarDatas() {
    //     this.listaAtividadeTipoNaoLancada.sort((a, b) => {
    //       const dataA = new Date(a.data.split("/").reverse().join("-"))
    //       const dataB = new Date(b.data.split("/").reverse().join("-"))
    //       return dataA - dataB
    //     })
    //   },

    baseMedia(item) {
        return [tipoDisciplina.tfg, tipoDisciplina.trabalhoConclusaCurso, tipoDisciplina.estagio].includes(item?.tipoDisciplina) || item?.tipoComponente === tabelaItem.tipoComponenteTFGEAD ? 7 : 6
    },

    alunoPertenceSituacao(aluno, situacao) {
        if (situacao === situacaoAluno.matriculado) {
            return (
                aluno.situacaoRealizado === situacao &&
                aluno.porcentagemPresenca >= 75
            )
        }

        if (situacao === situacaoAluno.reprovadoFrequencia) {
            return (
                aluno.porcentagemPresenca < 75 &&
                aluno.situacaoRealizado !== situacaoAluno.cancelado &&
                aluno.situacaoRealizado !== situacaoAluno.trancamento
            )
        }

        return situacao
            ? aluno.situacaoRealizado === situacao
            : true
    },

}


export default _util